/* WaveWear menu (ww-mega-menu.liquid + ww-menu-drawer.liquid)
   1. Desktop: open a panel on hover with a short delay (hover intent),
      keep it open while the pointer moves into it, close on Escape.
   2. Mobile drawer: accordion list, one item open at a time; the opened
      item scrolls to the top of the drawer.
      Dawn's MenuDrawer (global.js) binds a "close submenu" handler to every
      <button> inside the drawer. That would close the whole drawer when an accordion
      button is pressed, so clicks on our buttons are handled in
      the capture phase and stopped before they reach Dawn's handler. */
(function () {
  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 220;

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var top = item.querySelector('.ww-mm__top');
    if (top) top.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('[data-ww-mm-item].is-open').forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
  }

  function initDesktop(root) {
    root.querySelectorAll('[data-ww-mm-item]').forEach(function (item) {
      if (item.dataset.wwMmReady) return;
      item.dataset.wwMmReady = '1';
      var openTimer;
      var closeTimer;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          closeAll(item);
          setOpen(item, true);
        }, document.querySelector('[data-ww-mm-item].is-open') ? 0 : OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          setOpen(item, false);
        }, CLOSE_DELAY);
      });

      item.addEventListener('focusin', function () {
        closeAll(item);
        setOpen(item, true);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-ww-mm-item].is-open');
    if (!open) return;
    setOpen(open, false);
    var top = open.querySelector('.ww-mm__top');
    if (top) top.focus();
  });

  function setAcc(btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (body) body.hidden = !open;
  }

  document.addEventListener(
    'click',
    function (event) {
      var acc = event.target.closest('.ww-md [data-ww-acc]');
      if (!acc) return;
      event.stopPropagation();
      var opening = acc.getAttribute('aria-expanded') !== 'true';
      if (opening) {
        var list = acc.closest('.ww-md__list');
        if (list) {
          list.querySelectorAll('[data-ww-acc][aria-expanded="true"]').forEach(function (other) {
            if (other !== acc) setAcc(other, false);
          });
        }
      }
      setAcc(acc, opening);
      if (opening) {
        /* Bring the opened item to the top of the drawer. */
        var item = acc.closest('.ww-md__item');
        var scroller = acc.closest('.ww-md__inner');
        if (item && scroller) {
          requestAnimationFrame(function () {
            var top = item.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
            scroller.scrollTo({ top: top, behavior: 'smooth' });
          });
        }
      }
    },
    true
  );

  initDesktop(document);
  document.addEventListener('shopify:section:load', function (event) {
    initDesktop(event.target);
  });

  /* Theme editor: show the panel that holds the selected card block. */
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest('[data-ww-mm-item]');
    if (!item) return;
    closeAll(item);
    setOpen(item, true);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var item = event.target.closest && event.target.closest('[data-ww-mm-item]');
    if (item) setOpen(item, false);
  });
})();
